import ManhwaCard from '@/components/feature/ManhwaCard';
import { manhwas } from '@/mocks/manhwas';

export default function LatestSection() {
  const latest = [...manhwas]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 8);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100" aria-labelledby="latest-heading">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <h2 id="latest-heading" className="text-xl md:text-2xl font-heading text-foreground-950">
            最近更新
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最新章节第一时间同步，追更不等待</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {latest.map((m) => (
            <ManhwaCard key={m.id} manhwa={m} />
          ))}
        </div>
      </div>
    </section>
  );
}